import "inputmask/dist/jquery.inputmask.js";
import GoogleMap from "../utils/region";
import Tabs from "../modules/tabs";
import Search from "../modules/search";
import Validate from "../modules/validate";
import Calendar from "../modules/calendar";

const Rent = {
  selectedContainer: null,
  startDate: null,
  endDate: null,
  holidays: [],
  formData: {},
  mapEvent: new Event("map_loaded"),

  init() {
    if (document.body.classList.contains("woocommerce-order-received")) {
      return;
    }

    Calendar.init();
    Rent.renderMap();
    Tabs.init();
    Search.init();
    Rent.fetchHolidays();
    Rent.events();

    Rent.onLoad();
  },

  onLoad() {
    Rent.reset();

    // If checked input, set data.
    Rent.handleFirstStep();

    const selectedRegionInput = $("#tab2 input[name='region-pricing']:checked");

    if (selectedRegionInput.length > 0) {
      // Handle selected region
      let selectedRegion = selectedRegionInput
        .closest("[data-region]")
        .data("region");

      if (!selectedRegion) {
        return;
      }

      $("#tab2 button.nextTab").removeClass("inactive");

      Rent.handleSecondStep(selectedRegion);

      document.body.addEventListener("map_loaded", function () {
        GoogleMap.setActiveMarker(selectedRegion);
        Tabs.setActiveRegion(selectedRegion);
        Tabs.setActiveRegionStyle(selectedRegion);
      });

      // Load last step data
      Rent.handleThirdStep();

      // Show buttons
      $("#containerPolicy .approveOrder").removeClass("hidden");
    }
  },

  events() {
    $(".field__input.required").on("input", function () {
      $(this).closest(".field").removeClass("error");
    });

    //Selects container
    $(".rentContainer__options-wrap").on("click", function () {
      // Uncheck all inputs within the same group
      $(this).find("input").prop("checked", false);
      // Check the clicked input
      const input = $(this).find("input");
      input.prop("checked", true);
      // Trigger change event
      input.trigger("change");
    });

    // Handles the data update on container selection change
    $("#tab1 input[type='radio']").on("change", function () {
      Rent.handleFirstStep();
    });

    $("#tab2 input[type='radio']").on("change", function () {
      let isChecked = $("#tab2 input[type='radio']:checked").length > 0;
      if (isChecked) {
        $("#tab2 button.nextTab").removeClass("inactive");
      }
    });

    // Updates the topbar price from the selected region
    $("#tab2 input[name='region-pricing'").on("change", function () {
      let selectedRegion = $(this)
        .closest(".regionPricing__option")
        .data("region");

      Rent.handleSecondStep(selectedRegion);
    });

    // Handles AJAX calculations for last tab
    $("#tab3 button.nextTab").on("click", function (e) {
      Rent.handleThirdStep();
    });

    // Handles the container change on the last tab
    $(document).on("click", "#changeContainer", function () {
      Tabs.switchToTab(0);
      let offsetTop = $('#tab1').offset().top - 140;

      $("html, body").animate(
        {
          scrollTop: offsetTop,
        },
        750
      );
    });

    // Handles see terms and conditions button
    $("#rent-sumbit").on("click", function () {
      if (Validate.validate($("#service-form")[0])) {
        let offsetTop = $("#containerPolicy").offset().top - 140;
        $("html, body").animate(
          {
            scrollTop: offsetTop,
          },
          750
        );
        if (!$("button.accordion").hasClass("active")) {
          setTimeout(function () {
            $("button.accordion").trigger("click");
          }, 1000);
        }
      } else {
        let offsetTop = $("#service-form").offset().top - 140;
        $("html, body").animate(
          {
            scrollTop: offsetTop,
          },
          750
        );
      }
    });

    // Handles same as shipping address logic
    $("input[name='same-shipping-address']").on("change", function () {
      let isChecked = $(this).is(":checked");
      if (isChecked) {
        $("input[name='billing_address_1']")
          .val("")
          .addClass("disabled")
          .siblings(".field__label")
          .parent()
          .addClass("disabled")
          .removeClass("error");
      } else {
        $("input[name='billing_address_1']")
          .removeClass("disabled")
          .siblings(".field__label")
          .parent()
          .removeClass("disabled");
      }
    });

    // Submit form
    $(".orderNow button").on("click", function (e) {
      e.preventDefault();

      // Validate form data
      if (!Validate.validate($("#service-form")[0])) {
        // Scroll to the top of the form
        $("html, body").animate(
          {
            scrollTop: $("#service-form").offset().top - 250,
          },
          750
        );
        return;
      }

      // Check all terms are checked
      const termsEl = $("#containerPolicy [name=terms]");
      let allChecked = true;
      termsEl.each(function () {
        if (!$(this).is(":checked")) {
          allChecked = false;
        }
      });

      if (allChecked) {
        $(".orderNow button").text("").addClass("loading");

        // Submit the form
        $("#js-submit").click();
      }
    });

    // Filters the phone input field
    $('input[name="billing_phone"]').inputmask({ mask: "+37199999999", placeholder: '' });

    // Filters the phone input field
    $('input[name="person_code"]').inputmask({ mask: "999999-99999", placeholder: '      -     ' });

    // Filters bank account input field
    $('input[name="account_number"]').inputmask({
      regex: String.raw`^LV[A-Za-z0-9]{0,19}$`, placeholder: ''
    });

    // Filters registration number input field
    $('input[name="reg_nr"]').inputmask({ mask: "9{9,11}", placeholder: '' });

    // Filters pvn number input field
    $('input[name="pvn_nr"]').inputmask({ mask: "LV9{11}", placeholder: '' });
  },

  handleFirstStep() {
    // Remove inactive state if at least one radio is selected on tab 1
    let checkedEl = $("#tab1 input[type='radio']:checked");

    if (checkedEl.length > 0) {
      $("#tab1 button.nextTab").removeClass("inactive");
    } else {
      $("#tab2 input[name='region-pricing']").prop("checked", false);
      return;
    }

    // Updates the top bar and region prices with the selected container data
    let currElId = checkedEl.closest(".rentContainer__options-wrap").data("id");
    let currElData = Rent.fetchContainerData(currElId);

    Rent.selectedContainer = currElData;
    Rent.updateTopBarSizeSelection(currElData);
    Rent.updateRegionPrices(currElData);
    Rent.updateCalendarRentPrice(currElData.rent_price);
    Calendar.renderCalendar(currElData.disabled_dates);
    Rent.updateFormData("container_id", currElData.post_id);
    Rent.updateFormData("capacity", currElData.capacity);
  },

  handleSecondStep(selectedRegion = null) {
    if (!Rent.selectedContainer) {
      return;
    }

    GoogleMap.setActiveMarker(selectedRegion);

    let selectedRegionPrice = Rent.selectedContainer.pricing[selectedRegion];
    Rent.updateTopBarPrice(selectedRegionPrice);

    // Updates form data
    Rent.updateFormData("region_price", selectedRegionPrice);
    Rent.updateFormData("selected_region", selectedRegion);
  },

  handleThirdStep() {
    let formData = Rent.formData;
    formData.action = "calculate_order_totals";
    formData.lang = current_lang;

    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: formData,
    }).done((response) => {
      if (response.success) {
        $("#tab4 .orderDetails").html(response.data.html);
        $("#woocommerce-process-checkout-nonce").val(response.data.nonce);
      } else {
        console.error("Failed to calculate order totals");
      }
    });
  },

  reset() {
    const order = parseInt($(".rentContainer").data("order"));

    if (!isNaN(order)) {
      return;
    }

    // Resets all form data. Mostly used to workaround firefox saving form data.
    const radios = document.querySelectorAll('input[type="radio"]');
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');

    // Reset radio buttons
    for (const radio of radios) {
      radio.checked = false;
    }

    // Reset checkboxes
    for (const checkbox of checkboxes) {
      checkbox.checked = false;
    }
  },

  updateFormData(key, value) {
    Rent.formData[key] = value;
    //console.log("Updates form data. Key: " + key + ", value: " + value);
  },

  fetchContainerData(hashID) {
    try {
      const data = JSON.parse($("#catalog-data").text());
      let output = data[hashID];

      return output || null;
    } catch (error) {
      console.error("Failed to parse JSON data or find the item:", error);
      return null;
    }
  },

  fetchHolidays() {
    const data = JSON.parse($("#catalog-data").text());
    const holidays = data.holidays;
    Rent.holidays = holidays;
  },

  updateTopBarSizeSelection(selectedData) {
    // Loop over all tabs and update the selected container data.
    const $allTabs = $(".tab-content");
    $allTabs.each(function (index, el) {
      let $el = $(el);
      const $icon = $el.find(".selected-container-img");
      $icon.attr("src", selectedData.icon_link);

      let $capacity = $el.find(".formSteps__step--size p span");
      $capacity.text(` ${selectedData.capacity} m3`);
    });
  },

  updateCalendarRentPrice(price) {
    // Update the rent price in the calendar
    $("#tab3 .calendarContent #rentPrice").text(price);
  },

  updateRegionPrices(selectedData) {
    // Update region prices
    const $secondStep = $("#tab2");
    let $regionPrices = $secondStep.find(".regionPricing__option");
    $regionPrices.each(function (index, el) {
      let $el = $(el);
      let regionPrice = selectedData.pricing[$el.data("region")];
      $el
        .find(".regionPricing__price strong")
        .text(`${(regionPrice * 1.21).toFixed(2)} €`);
      // Subtract 21% VAT
      $el.find(".regionPricing__price span").text(`(${regionPrice} € Bez PVN)`);
      $el.find("#rentPrice").text(selectedData.rent_price);
    });
  },

  updateTopBarPrice(price) {
    // Update top bar price
    const $allTabs = $(".tab-content");
    $allTabs.each(function (index, el) {
      let $el = $(el);

      let $priceEl = $el.find(".formSteps__step--price p span");
      $priceEl.text(` ${(price * 1.21).toFixed(2)} €`);
    });
  },

  updateTopBarRent(days, price) {
    // Update the rent summary price
    let totalPrice = 0;
    totalPrice = days * price;

    $("#tab4 .formSteps__step--rent p span").text(
      ` ${(totalPrice * 1.21).toFixed(2)} €`
    );
  },

  getRentSum(days, price) {
    let totalPrice = 0;
    totalPrice = days * price;

    return totalPrice;
  },

  dateRangeHandler() {
    if (Rent.selectedContainer === null) {
      return;
    }

    let startDate = Rent.dateToDayMonth(Rent.startDate);
    let endDate = Rent.dateToDayMonth(Rent.endDate);

    // Update the date range in the top bar
    $("#tab4 .formSteps__step--dates p span").text(
      `${startDate} līdz ${endDate}`
    );

    // Remove button inactive state
    $("#tab3 button.nextTab").removeClass("inactive");

    // Calculate the total days and price
    let totalDays = Rent.countRangeDays(Rent.startDate, Rent.endDate);
    let price = Rent.selectedContainer.rent_price;

    Rent.updateTopBarRent(totalDays, price);

    // Updates form data
    Rent.updateFormData("rent_billable_days", totalDays);
    Rent.updateFormData("rent_sum", Rent.getRentSum(totalDays, price));
    Rent.updateFormData("start_date", Rent.dateToString(Rent.startDate));
    Rent.updateFormData("end_date", Rent.dateToString(Rent.endDate));
  },

  countRangeDays(startDate, endDate) {
    let count = 0;
    let currentDate = new Date(startDate);
    const endDatePlusOne = new Date(endDate);
    endDatePlusOne.setDate(endDatePlusOne.getDate() + 1);

    // Prepare a set for faster lookup if holidays are in an array
    const holidaysSet = new Set(Rent.holidays);

    // Loop over each day between dates
    while (currentDate < endDatePlusOne) {
      let dateString = currentDate.toISOString().split("T")[0]; // Format as 'YYYY-MM-DD'
      let dayOfWeek = currentDate.getDay();

      // Weekdays are Monday (1) to Friday (5)
      // Also check if it's not a holiday
      if (dayOfWeek !== 0 && dayOfWeek !== 6 && !holidaysSet.has(dateString)) {
        count++;
      }

      // Move to the next day
      currentDate.setDate(currentDate.getDate() + 1);
    }

    if (count <= 3) {
      count = 0;
    } else {
      count -= 3;
    }

    return count;
  },

  dateToString(date) {
    let month = "" + (date.getMonth() + 1),
      day = "" + date.getDate(),
      year = date.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  },

  dateToDayMonth(d, locale = "lv") {
    // Define translations for month names in various languages
    const translations = {
      en: [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ],
      lv: [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAIJ",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ],
      lt: [
        "SAU",
        "VAS",
        "KOV",
        "BAL",
        "GEG",
        "BIR",
        "LIE",
        "RGP",
        "RGS",
        "SPA",
        "LAP",
        "GRD",
      ],
    };

    // Get day and month index
    let day = "" + d.getDate(),
      monthIndex = d.getMonth();

    // Use the locale to get the correct month names
    const monthNames = translations[locale] || translations["lv"];

    // Format and return the date string
    return `${day}. ${monthNames[monthIndex]}`;
  },

  renderMap() {
    const mapEl = $("#region-map");

    if (!mapEl.length) {
      return;
    }

    const data = {
      lat: 56.9070943,
      lng: 24.0749061,
      zoom: 9,
    };

    GoogleMap.create(data, mapEl);
  },

  setInputFilter(textbox, inputFilter) {
    [
      "input",
      "keydown",
      "keyup",
      "mousedown",
      "mouseup",
      "select",
      "contextmenu",
      "drop",
    ].forEach(function (event) {
      textbox.addEventListener(event, function () {
        if (inputFilter(this.value)) {
          this.oldValue = this.value;
          this.oldSelectionStart = this.selectionStart;
          this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty("oldValue")) {
          this.value = this.oldValue;
          this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        } else {
          this.value = "";
        }
      });
    });
  },
};

export default Rent;
